import {NoteLinkedDataType} from 'constants/ModelTypeConstants';
import * as TaskRunner from 'util/TaskRunner';

export function downloadNoteLinkedData({
  entryId,
  versionDbId,
  apiType,
  uuid,
}: {
  entryId: string;
  versionDbId: number;
  apiType: NoteLinkedDataType;
  uuid: string | number;
}): JQueryPromise<{url: string}> {
  return TaskRunner.postJSON({
    url: `/1/api/entries/${entryId}/${versionDbId}/${apiType}/${uuid}:download`,
  });
}
